import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  Avatar,
  Paper,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import axios from "../../api/axios";
import { useNavigate } from "react-router-dom";
import { useAuthDispatch } from "../../context/AuthContext";

const SignUp = () => {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");

    if (form.password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    if (!emailRegex.test(form.email)) {
      setError("Please enter a valid email.");
      return;
    }

    try {
      await axios.post("/api/v1/auth/register", form);
      setSuccessMessage(
        "Account successfully created. Redirecting to login..."
      );
      setForm({ username: "", email: "", password: "" });
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err.response?.data?.message || "Sign Up failed");
    }
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Paper elevation={2} sx={{ padding: 3, mt: 10, borderRadius: 2 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Avatar sx={{ m: 1, bgcolor: "primary.main", width: 40, height: 40 }}>
            <LockOutlinedIcon fontSize="small" />
          </Avatar>
          <Typography variant="h6" gutterBottom>
            Create Account
          </Typography>

          {error && (
            <Typography color="error" sx={{ mt: 1, fontSize: "0.85rem" }}>
              {error}
            </Typography>
          )}
          {successMessage && (
            <Typography
              color="success.main"
              sx={{ mt: 1, fontSize: "0.85rem" }}
            >
              {successMessage}
            </Typography>
          )}

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ mt: 2, width: "100%" }}
          >
            <TextField
              fullWidth
              label="Username"
              name="username"
              value={form.username}
              onChange={handleChange}
              size="small"
              margin="dense"
              required
            />
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              size="small"
              margin="dense"
              required
            />
            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              size="small"
              margin="dense"
              required
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="small"
              sx={{ mt: 2 }}
            >
              Sign Up
            </Button>
          </Box>

          <Box mt={2}>
            <Typography variant="caption">
              Already have an account?{" "}
              <a
                href="/login"
                style={{ color: "#1976d2", textDecoration: "none" }}
              >
                Login
              </a>
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default SignUp;
